import { Vector3 } from "three";
import React, { useEffect, useState } from "react";
import Taats from "../../doors/taats";
import { ConfigurationProps } from "../../Door";
import { useConfigurationOptionsContext } from "../../../../../app/providers/DoorOptionsProvider";

interface DoubleTaatsProps extends ConfigurationProps {}
const DoubleTaats: React.FC<DoubleTaatsProps> = ({
  materials,
  position,
  rotation,
  scale,
  doorSettings,
}: DoubleTaatsProps) => {
  const taatsPosition0 = new Vector3(-0.459, 0, 0);
  const taatsPosition1 = new Vector3(0.459, 0, 0);

  const { eigenwijs, getConfigurationPositions } =
    useConfigurationOptionsContext();

  const [positions, setPositions] = useState<Vector3[]>([]);

  useEffect(() => {
    setPositions(getConfigurationPositions([taatsPosition0, taatsPosition1]));
  }, [eigenwijs?.sizeObjects]);

  return (
    <group position={position} scale={scale}>
      <Taats
        materials={materials}
        position={positions[0]}
        rotation={rotation}
        index={0}
        frameSettings={doorSettings?.main?.frameSettings}
      />
      <Taats materials={materials} position={positions[1]} index={1} />
    </group>
  );
};

export default DoubleTaats;
